<script>
    export let isMuted;
</script>

{#if isMuted}
    <i class="fa-thin fa-volume-slash red"></i>
{:else}
    <i class="fa-thin fa-volume"></i>
{/if}

<style lang="scss">
  .red {
    color: red;
  }
</style>
